import type { Point } from '../../core/types/point.js';

/**
 * Converts polar coordinates to Cartesian coordinates.
 *
 * @param radius - The radius (distance from the origin).
 * @param angle - The angle in radians, measured from the positive x-axis.
 * @returns An object containing the x and y coordinates.
 */
export const polarToCartesian = (radius: number, angle: number): Point => {
  return {
    x: Math.cos(angle - 0.5 * Math.PI) * radius,
    y: Math.sin(angle - 0.5 * Math.PI) * radius,
  };
};
